import { LoadingOutlined } from "@ant-design/icons";

export function Loading({
  fontSize,
  color,
}: {
  fontSize?: number;
  color?: string;
}) {
  return (
    <LoadingOutlined style={{ fontSize, color }} className="animate-spin" />
  );
}
